// extracted by mini-css-extract-plugin
export const root = "r_r";
export const paper = "r_s";
export const title = "r_x";
export const btnUpdate = "r_w";
export const titleSection = "r_S";
export const mapLink = "r_T";
export const deleteBtn = "r_V";
export const newsRoot = "r_W";
export const pagination = "r_X";
export const noJetsoRoot = "r_Y";